export const DefaultLinkName: string = "CityList";
export const DefaultPageSize: number = 20;
export const DefaultPage: number = 1;
